module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_strengths_img-b512d2047fa5794c79dd835f57f452e6.jpg";